import { render, staticRenderFns } from "./claim-register.vue?vue&type=template&id=9a708c86&"
import script from "./claim-register.vue?vue&type=script&lang=js&"
export * from "./claim-register.vue?vue&type=script&lang=js&"
import style0 from "./claim-register.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports